import React from 'react'
import { UNKNOWN_SERVER_ERROR_CTA_MSG, UNKNOWN_SERVER_ERROR_MSG } from '../../constants/Errors'
import { camelToTitle } from '../../utils'

const ServerError = ({ message = UNKNOWN_SERVER_ERROR_MSG, cta = UNKNOWN_SERVER_ERROR_CTA_MSG }) => (
  <div className="bp3-callout bp3-intent-danger">
    <h4 className="bp3-heading">{message}</h4>
    {cta}
  </div>
)

const SerializedErrors = ({ safeErrors }) => (
  <ul>
    {Object.keys(safeErrors).map(key => (
      <li key={key}>
        <strong>{camelToTitle(key)} </strong>
        {safeErrors[key].join(', ')}
      </li>
    ))}
  </ul>
)

const APIErrorCallout = ({ response }) => {
  const safeData = (response && response.data) || {}
  const safeErrors = (safeData && safeData.errors) || {}
  const shouldSerialize = Object.keys(safeErrors).length > 0

  if (!response) {
    return <ServerError />
  }

  if (!response.status) {
    return <ServerError />
  }

  if (response.status >= 500) {
    return <ServerError message={safeData.message} />
  }

  return (
    <div className="bp3-callout bp3-intent-danger">
      <h4 className="bp3-heading">{safeData.message || 'Errors'}</h4>
      {shouldSerialize && <SerializedErrors safeErrors={safeErrors} />}
    </div>
  )
}

export default APIErrorCallout
